import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MobileSecurityCustomerViewDataProviderFactory } from '../factory/MobileSecurityCustomerViewDataProviderFactory';
import { MobileSecurityCustomerViewDataProvider } from '../dataProvider/MobileSecurityCustomerViewDataProvider';
import { MobileSecurityCompanyRecord } from '../../mobileSecurityCompanyGrid/types';

export class MobileSecurityCustomerViewRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MobileSecurityCustomerViewDataProviderFactory;
  public dataProvider: MobileSecurityCustomerViewDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MobileSecurityCustomerViewDataProviderFactory(),
    });
  }

  public async getCompany(): Promise<MobileSecurityCompanyRecord | undefined> {
    return this.dataProvider.getCompany();
  }
}
